export default {
    getHeaderFieldsPTBT: state => state.headerFieldsPTBT,
    getFormActions: state => state.formActions,
    getActionsPTBT: state => state.actionsPTBT,
    getRowActions: state => state.rowActions,
    getAdditionalTableConfig: state => state.dataTableOptions
}
